export default "__VITE_ASSET__6fbda4e2__"